import { useEffect, useState } from 'react'
import { throttle } from 'lodash'
import { theme } from '../theme'

const checkMobile = () => {
  return window.innerWidth <= theme.breakpoint.s
}

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState<boolean>(checkMobile())

  const handleCheck = throttle(() => {
    setIsMobile(checkMobile())
  }, 100)

  useEffect(() => {
    handleCheck()
    window.addEventListener('resize', handleCheck)

    return () => {
      window.removeEventListener('resize', handleCheck)
    }
  }, [])

  return { isMobile }
}
